// ===========================================
// Parent Hybrid Booking Page
// ===========================================
// Thin wrapper around IndividualBookingTab with a page header.
// All booking logic lives in IndividualBookingTab to avoid code duplication.

import { Box } from '@mui/material';
import PageHeader from '../../components/common/PageHeader';
import IndividualBookingTab from '../../components/booking/IndividualBookingTab';

export default function HybridBookingPage() {
  return (
    <Box>
      <PageHeader
        title="Book Individual Sessions"
        subtitle="Select time slots for your child's individual lessons"
      />
      <IndividualBookingTab />
    </Box>
  );
}
